import Vue, { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router'

import { FontAwesomeIcon } from '@/plugins/font-awesome'

import ccColors from '@/components/ccColors.vue'

import ccError from '@/components/ccError.vue'
import ccLoading from '@/components/ccLoading.vue'
import ccLoadingComponent from '@/components/ccLoadingComponent.vue'

// Climacheck Amchart Components
import ccDistributionChart from '@/components/amcharts/ccDistribution.vue'
import ccUsedAndGenerated from '@/components/amcharts/ccUsedAndGenerated.vue'
import ccEnergyPerTime from '@/components/amcharts/ccEnergyPerTime.vue'
import ccTemperatureOccurrence from '@/components/amcharts/ccTemperatureOccurrence.vue'
import ccEnergyPerTemperature from '@/components/amcharts/ccEnergyPerTemperature.vue'
import ccAverageCOP from '@/components/amcharts/ccAverageCOP.vue'
import ccCOPPerTemperature from '@/components/amcharts/ccCOPPerTemperature.vue'

import { createI18n } from 'vue-i18n'
import store from '@/store/store'

require('@/assets/main.scss')

const i18nTexts = {
  en: require('@/assets/i18n/en.json'),
  sv: require('@/assets/i18n/sv.json')
}

const i18n = createI18n({
  // vue-i18n options
  locale: 'en', // set locale
  fallbackLocale: 'sv', // set fallback locale
  messages: i18nTexts
})

createApp(App)
  .use(store)
  .use(router)
  .use(i18n)
  .component('fa', FontAwesomeIcon)
  .component('ccError', ccError)
  .component('ccLoading', ccLoading)
  .component('ccLoadingComponent', ccLoadingComponent)
  .component('ccDistributionChart', ccDistributionChart)
  .component('ccUsedAndGenerated', ccUsedAndGenerated)
  .component('ccEnergyPerTime', ccEnergyPerTime)
  .component('ccTemperatureOccurrence', ccTemperatureOccurrence)
  .component('ccEnergyPerTemperature', ccEnergyPerTemperature)
  .component('ccAverageCOP', ccAverageCOP)
  .component('ccCOPPerTemperature', ccCOPPerTemperature)
  .mount('#app')
